import React from 'react'
import PropTypes from 'prop-types'
import { Container, Paragraph } from '@scentregroup/ui'
import classNames from 'classnames'
import style from './index.scss'
const OpeningHoursBanner = ({ text, hours }) => {
  const addComma = () => text.description && ', '
  return (
    <Container
      className={classNames(style.container, style.openingHoursBanner)}
      type="large"
    >
      <Paragraph
        className={classNames(
          style.openingHoursBannerParagraph,
          text.isColored ? style.isSpecialDescription : undefined
        )}
      >
        <span className={style.hourText}>{`${hours}${addComma()}`}</span>
        <span>{text.description || ''}</span>
      </Paragraph>
    </Container>
  )
}

OpeningHoursBanner.propTypes = {
  hours: PropTypes.string.isRequired,
  text: PropTypes.object.isRequired,
}

export default OpeningHoursBanner
